<template>
  <div :style="{ height: showNav ? '100px' : '60px' }">
    <div id="PublicHeader" :class="`wise-public-header ${isLogin && !showHeader ? 'show' : ''} ${showNav ? 'show-nav' : ''}`">
      <div v-show="showHeader" class="wise-containner">
        <div class="wise-nav">
          <!-- Logo -->
          <img class="logo" :src="`${oss_url}/freesailing_logo.png`" @click="go2navigationPage('/')" />

          <!-- 路由菜单 -->
          <div class="wise-item" :class="{ show: showDropTab === nav.tabName }" v-for="(nav, i) in navList" :key="i" @click="go2navigationPage(nav.href, nav.code)" @mouseover="showSubMenu(nav.tabName)" @mouseleave="hideSubMenu()">
            <span class="navtxt" :class="{ blue: nav.tabName === currentTab }">{{ nav.label }}</span>
            <template v-if="nav.children">
              <span class="arrow"></span>
              <div class="downBox">
                <div class="content">
                  <span class="downItem" v-for="(v, j) in nav.children" :key="j" @click="go2navigationPage(v.href, v.code, nav.tabName)">
                    <span>{{ v.label }}</span>
                  </span>
                </div>
              </div>
            </template>
            <span v-else style="display: inline-block; width: 10px"></span>
          </div>

          <!-- <div class="wise-item" :class="{ blue: currentTab === 'industry' }" @click="go2navigationPage('/industry/list')">
            <span class="navtxt">行业动态</span>
            <span style="display: inline-block; width: 10px"></span>
          </div>
          <div class="wise-item" :class="{ blue: currentTab === 'about' }" @click="go2navigationPage('/about')">
            <span class="navtxt">关于我们</span>
            <span style="display: inline-block; width: 10px"></span>
          </div> -->
        </div>

        <!-- 右侧 -->
        <div class="wise-header">
          <div class="wise-item" v-if="userToken && tableData && tableData.length > 0" :class="{ blue: currentTab === 'industry' }" @click="go2navigationPage('/introduce/four')">
            <span class="navtxt breathing-text" style="color: #ff701d">新客活动收益</span>
          </div>

          <div v-if="userInfo && userInfo.userId" class="message">
            <!-- 系统消息 -->
            <div class="item" :class="showMsg ? 'show' : ''" @mouseover="showMessage" @mouseleave="hideMessage">
              <el-badge :is-dot="Number(noticeCount) > 0">
                <i class="el-icon el-icon-bell"></i>
              </el-badge>
              <div class="messageBox sys" ref="messageRef">
                <Message title="消息" @toUrl="toUrl" @closeMessage="closeMessage" @checkMessage="checkMessage" />
              </div>
            </div>
            <div v-if="showItemLayer" ref="itemLayerRef" class="item-layer"></div>
          </div>

          <div v-if="userInfo && userInfo.userId" class="message">
            <!-- 用户中心 -->
            <div class="item">
              <el-tooltip popper-class="user-pop" effect="light" content="点击进入用户中心" placement="bottom">
                <i class="el-icon el-icon-user" @click="goUserCenter"></i>
              </el-tooltip>
            </div>
          </div>

          <!--  -->
          <div v-if="userInfo && userInfo.userId" class="header-btn" :class="{ show: showDropTab === 'user' }" @mouseover="showSubMenu('user')" @mouseleave="hideSubMenu()">
            <img class="headerAvatar" width="40" height="40" :src="avatar" @error="handleErrorImg" />
            <span class="arrow"></span>
            <div class="downBox">
              <div class="content" style="width: 240px">
                <p class="downItem acc">
                  <span style="width: 179px" class="ellipsis">{{ userInfo.nickname || userInfo.phone }}</span>
                  <img width="16px" :src="applyImg" />
                </p>

                <a class="downItem" @click="goUserCenter">
                  <span>用户中心</span>
                  <span class="arrow-right"></span>
                </a>

                <el-divider class="user-divider" />

                <span class="downItem logoutBtn" @click="handleLogout">
                  <span>退出登录</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="loginBtn" @click="toRegisterPage">
            <span>登录/注册</span>
          </div>
        </div>
      </div>

      <!-- 显示常用菜单 -->
      <div class="top-nav">
        <div class="top-nav-title"><i class="el-icon-menu"></i> 常用入口</div>
        <div class="top-nav-item" :class="currentHref == v.href || currentHref == v.href + '/' ? 'active' : ''" v-for="(v, index) in commonNav" :key="index" @click="go2navigationPage(v.href, v.code)">
          <img class="icon" :src="require(`@/assets/icons/${v.code}.png`)" />
          {{ v.label }}
        </div>
      </div>
    </div>

    <Popup v-if="popType" :popType="popType" @enter="enter" @close="close" />
    <ContactQQ v-if="showHeader"></ContactQQ>
  </div>
</template>

<script>
import actions from '@/actions'
import { mapMutations, mapGetters } from 'vuex'
import ContactQQ from '@/components/ContactQQ.vue'
import Popup from '@/components/Popup.vue'
import NoticeListDialog from '@/components/NoticeListDialog.vue'
import Message from '@/components/message/index.vue'
import { activityOrderStatistic } from '@/api/user'

import { fetchUserInfo, fetchCompanyApply, getAccount, getMenubar, checkAccountAmount, setAmountWarn, fetchProductList, fetchNoticeList } from '@/api/user'
import { oss_url, userRule, _ENUM_CODE, pathOfHome } from '@/utils'
import { toRegisterPage, toHomePage, go2Page, getRightJumpPageByPathname, getRouterName } from '@/utils/functions'
import router from '@/router'

let timer
let timerMount

export default {
  name: 'PublicHeader',
  components: { ContactQQ, NoticeListDialog, Message },
  props: {
    setIsAdmin: Function
  },
  data() {
    return {
      oss_url,
      userRule,
      popType: false,
      checked: false,

      imgErrorTimes: 0,
      isShowNoticeDialog: true,
      href: '',
      code: '',
      gotype: '',
      showMsg: false,
      showNotice: false,
      showItemLayer: false,

      showHeader: false,
      showNav: true,
      commonNav: [],

      navList: [
        { label: '首页', href: '/', tabName: 'home' },
        { label: '货代工具箱', href: '/rpaControl/rpaStore', tabName: 'rpaControl' },
        {
          label: '数据发送',
          href: '',
          tabName: 'send',
          children: [
            { label: '预配舱单-上海', href: '/cps', code: _ENUM_CODE.SHCPS },
            { label: '预配舱单-青岛', href: '/cpsqd', code: _ENUM_CODE.QDCPS },
            { label: 'VGM发送', href: '/vgm', code: _ENUM_CODE.VGM },
            { label: 'AMS发送', href: '/ams', code: _ENUM_CODE.AMS },
            { label: 'ISF发送', href: '/isf', code: _ENUM_CODE.ISF },
            { label: 'EM发送', href: '/em', code: _ENUM_CODE.EM },
            { label: 'ACI发送', href: '/aci', code: _ENUM_CODE.ACI },
            { label: 'AFR发送', href: '/afr', code: _ENUM_CODE.AFR }
          ]
        },
        {
          label: '海运跟踪',
          href: '',
          tabName: 'shipping',
          children: [
            { label: '进出口箱货跟踪-上海', href: '/track-sh', code: '' },
            { label: '箱货跟踪-宁波', href: '/track-nb', code: '' },
            { label: '开截港查询-上海', href: '/schedule', code: '' },
            { label: '全链路跟踪', href: '/fullLink', code: '' }
          ]
        },
        { label: '无忧代理人', href: '/agent', tabName: 'agent', code: _ENUM_CODE.AGENT },
        {
          label: '运价查询',
          href: '',
          tabName: 'freight',
          children: [
            { label: '运价查询', href: '/freight', code: '' },
            { label: '收藏订阅', href: '/freight/favorites', code: '' },
            { label: '运价趋势', href: '/freight/chart', code: '' }
          ]
        }
      ],
      showDropTab: null,
      tableData: [],
      userToken: '',

      productEnable: {},
      productStatus: {}
    }
  },
  computed: {
    ...mapGetters(['currentHref', 'noticeCount']),
    isLogin() {
      if (this.$store.getters.isLogin) {
        actions.setGlobalState({ isLogin: this.$store.getters.isLogin })
        // 登录状态获取用户未读消息\公告等
        this.getAllNotice()
      }
      return this.$store.getters.isLogin
    },
    hasCompany() {
      actions.setGlobalState({ hasCompany: this.$store.getters.hasCompany })
      return this.$store.getters.hasCompany
    },
    userInfo() {
      if (this.$store.getters.userInfo) {
        actions.setGlobalState({ userInfo: this.$store.getters.userInfo })
      }
      return this.$store.getters.userInfo
    },
    applyImg() {
      return oss_url + (this.userInfo.companyStatus === 20 ? '/company-apply.png' : '/company-unapply.png')
    },
    // 头像
    avatar() {
      return this.userInfo.avatar || 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/userImg.png'
    },
    currentTab() {
      return this.$store.getters.currentTab
    }
  },

  async created() {
    this.userToken = localStorage.getItem('userToken')
    if (this.userToken) {
      this.getActivityOrderStatistic()
    } else {
      this.tableData = []
    }
    this.menubar()

    let path = location.pathname
    this.setCurrentTab(getRouterName(path))
    this.setCurrentHref(path)

    // 第一次登录
    if (localStorage.getItem('firstLogin') == 1) {
      const res = await checkAccountAmount()
      // this.showMsg = res.data ? true : false
      // this.showItemLayer = res.data ? true : false
      localStorage.setItem('firstLogin', '2')
    }

    this.checked = localStorage.getItem('checked') == 'true' ? true : false

    // 获取必须的基本数据 —— 用户信息
    let [userInfo, companyInfo, amount] = await Promise.allSettled([this.getUserInfo(), this.getCompanyApply(), this.getAccount()])

    if (userInfo.value) {
      // 登录状态时获取用户开通的产品
      this.getProductList()

      // 检查用户是否是企业管理员
      Array.isArray(userInfo.value.roles) &&
        userInfo.value.roles.map(d => {
          if (d == 'admin') {
            this.$emit('setIsAdmin')
          }
        })
    }

    let data = {
      userInfo: undefined,
      companyInfo: undefined
    }

    if (userInfo.status === 'fulfilled') {
      data.userInfo = userInfo.value
    }

    if (companyInfo.status === 'fulfilled') {
      data.companyInfo = companyInfo.value
    }

    // 获取用户余额
    if (data && data.userInfo && data.userInfo.amount && localStorage.getItem('firstLogin') != 3) {
      if (data.userInfo.amount < 100) {
        const res = await checkAccountAmount()
        // this.showMsg = res.data ? true : false
        // this.showItemLayer = res.data ? true : false
        this.checked = false
      }
    }

    // 根据地址、登录、企业认证、产品开通状态判断是否需要去落地页
    let url = await getRightJumpPageByPathname({
      isLogin: !!userInfo?.value?.userId,
      hasCompany: companyInfo?.value?.status === 20
    })
    url && (location.href = url)

    this.setUserInfo(data.userInfo)
    this.setCompanyInfo(data.companyInfo)
    actions.setGlobalState({ companyInfo: data.companyInfo })

    // 显示公告组件（属于首页和用户中心的页面不显示）
    if (!/^\/user/.test(location.pathname) && !pathOfHome.includes(location.pathname)) {
      this.isShowNoticeDialog = true
    }
  },

  mounted() {
    window.onload = () => {
      this.showHeader =
        !!document.getElementById('appContainer') || // 乾坤主应用、
        !!document.getElementById('PublicHeader')
    }
  },

  unmounted() {
    clearInterval(timerMount)
  },

  methods: {
    ...mapMutations('user', ['initState', 'setIsLogin', 'setHasCompany', 'setUserInfo', 'setCompanyInfo', 'setOpenedProducts', 'setOpenedStatus', 'setCurrentTab', 'setCurrentHref', 'setNoticeCount']),
    toRegisterPage,
    getActivityOrderStatistic() {
      activityOrderStatistic().then(res => {
        this.tableData = res.data
      })
    },

    // 获取菜单列表
    menubar() {
      getMenubar().then(res => {
        let navs = []
        res.data.map(d => {
          if (d.label === '数据发送') {
            navs = d.children
          }
        })
        // navs.push({ children: null, code: 'ics', createTime: '', enable: true, href: '/ics', id: 13, label: 'ICS2发送', pid: 13, sort: 4, tabName: '', updateTime: '' })
        this.commonNav = navs
        this.navList = res.data
      })
    },

    // 获取全部未读消息
    async getAllNotice() {
      const parmas = { isRead: 0, pageNum: 1, pageSize: 100 }
      const resp = await fetchNoticeList(parmas)
      if (resp.success) {
        // if (resp.data) this.showMsg = resp.data.total > 0 ? true : false
        this.setNoticeCount(resp.data.total)
        actions.setGlobalState({ noticeCount: resp.data.total })
      }
    },

    // 检查是否 有未读站内消息
    checkMessage() {
      this.showMsg = true
      this.showNotice = true
    },

    // 获取用户信息
    goUserCenter() {
      if ('/user' === location.pathname) return

      if (window.location.pathname.search('cpsqd') != 1) {
        localStorage.setItem('popType', '')
      }
      if (localStorage.getItem('popType') && localStorage.getItem('popType') == 'qingdao') {
        this.popType = true
        this.gotype = 'userCenter'
      } else {
        // location.href = window.location.origin + '/user'
        this.toUrl('/user')
      }
    },

    // 获取用户信息，并返回
    async getAccount() {
      let count = (await getAccount()).data
      return count
    },

    // 获取用户信息，并返回
    async getUserInfo() {
      let user = (await fetchUserInfo()).data
      return user
    },

    // 获取已开通的产品
    async getProductList() {
      const resp = await fetchProductList()
      const { success, data } = resp

      if (success) {
        // console.log('开通产品', data)

        const obj = {}
        const enable = {}
        data.forEach(v => {
          if (v.code == 'ICS') {
            obj['ics'] = v.status
            enable[['ics']] = v.enable
          } else {
            obj[v.code] = v.status
            enable[v.code] = v.enable
          }
        })
        this.productEnable = enable
        this.productStatus = obj
        this.setOpenedProducts(obj)
        this.setOpenedStatus(enable)
      }
    },

    // 获取公司认证信息
    async getCompanyApply() {
      let { success, data, msg } = await fetchCompanyApply()
      if (success && data) {
        return data
      }
      return {}
    },

    close() {
      this.popType = false
    },

    enter() {
      this.popType = false
      let href = this.href
      let code = this.code
      localStorage.setItem('popType', '')
      window.popType = ''
      if (this.gotype == 'chongzhi') {
        location.href = window.location.origin + '/user/finance/balance'
      }
      if (this.gotype == 'nav') {
        let { isLogin, hasCompany } = this

        go2Page({ href, code, isLogin, hasCompany })
      }
      if (this.gotype == 'logput') {
        localStorage.removeItem('userToken')
        Object.assign(this.$data, this.$options.data())
        this.$nextTick(() => {
          ![`${userRule}/register`].includes(location.pathname) && toHomePage()
        })
      }

      if (this.gotype == 'userCenter') {
        location.href = window.location.origin + '/user'
      }
    },

    // 跳转页面
    toUrl(href) {
      this.setCurrentTab(getRouterName(href))
      this.setCurrentHref(href)
      this.checkRendMessage(href)

      router.push(href)
    },

    // 点击导航跳转事件
    async go2navigationPage(href, code) {
      // console.log('点击导航跳转事件', href, location.pathname)
      if (href === location.pathname) return

      this.href = href
      this.code = code
      this.hideSubMenu()

      if (window.location.pathname.search('cpsqd') != 1) {
        localStorage.setItem('popType', '')
      }

      // popType 不为空
      if (localStorage.getItem('popType') && localStorage.getItem('popType') == 'qingdao') {
        this.popType = true
        this.gotype = 'nav'
      }
      //
      else {
        let { isLogin, hasCompany, userInfo, productEnable, productStatus } = this
        const isBool = await go2Page({ href, code, isLogin, hasCompany, userInfo, productEnable, productStatus })

        if (isBool) {
          timer = setTimeout(() => {
            let path = location.pathname
            this.setCurrentTab(getRouterName(path))
            this.setCurrentHref(href)
            //
            this.checkRendMessage(path)

            clearTimeout(timer)
          }, 20)
        }
      }
    },

    // 检查是否需要读取消息接口
    checkRendMessage(path) {
      // 如果跳转到以下子组件，更新子组件存储在sotre里的名称，用于是否调用获取消息接口
      const names = ['/', 'home', 'cps', 'cpsqd', 'vgm', 'ams', 'em', 'aci', 'afr', 'isf', 'ics', 'track', 'freight', 'user']
      names.map(n => {
        if (n && path.indexOf(n) !== -1) {
          this.$store.commit('user/setChildName', n == '/' ? 'home' : n)
        }
      })
    },

    // 退出登录
    handleLogout() {
      if (window.location.pathname.search('cpsqd') != 1) {
        localStorage.setItem('popType', '')
      }
      if (localStorage.getItem('popType') && localStorage.getItem('popType') == 'qingdao') {
        this.popType = true
        this.gotype = 'logput'
      } else {
        localStorage.removeItem('userToken')
        this.setUserInfo({})
        Object.assign(this.$data, this.$options.data())
        this.$nextTick(() => {
          ![`${userRule}/register`].includes(location.pathname) && toHomePage()
        })
      }
    },

    handleErrorImg(event) {
      if (this.imgErrorTimes < 1) {
        event.target.src = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/userImg.png'
        this.imgErrorTimes++
      }
    },

    // 显示下拉菜单
    showSubMenu(tabName) {
      this.showDropTab = tabName
    },

    // 隐藏下拉菜单
    hideSubMenu() {
      this.showDropTab = null
    },

    // 显示消息浮窗
    showMessage() {
      this.showMsg = true
    },

    // 关闭消息浮窗
    hideMessage() {
      if (this.showItemLayer) return
      if (this.showNotice) return
      this.showMsg = false
      this.showItemLayer = false
    },

    // 主动关闭消息浮窗
    closeMessage() {
      this.showItemLayer = true

      timer = setTimeout(() => {
        this.$refs.itemLayerRef.style.zIndex = 100
        this.showMsg = false
        this.showNotice = false
      })

      timer = setTimeout(() => {
        this.showItemLayer = false
        this.$refs.itemLayerRef.style.zIndex = 1
        clearTimeout(timer)
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
